import React, { Suspense, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { FullPageSpinner } from '@/components/ui/loading-spinner';
import { AuthLandingPage } from './standaloneRoutePages';

export const PageLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<FullPageSpinner message="Loading..." />}>{children}</Suspense>
);

const getTargetRouteForRole = (role: string): string => {
  switch (role) {
    case 'super_admin':
      return '/operations';
    case 'tenant':
    case 'resident':
      return '/tenant';
    case 'vendor_tech':
      return '/vendor-tech';
    case 'vendor_admin':
    case 'vendor_manager':
      return '/vendor-management';
    case 'maintenance_tech':
      return '/maintenance-team';
    default:
      if (['vendorshield_company_admin', 'vendorshield_company_manager', 'vendorshield_coordinator'].includes(role)) {
        return '/vendorshield-pro';
      }
      return '/operations';
  }
};

export const RootRoute = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    const vendorRedirect = sessionStorage.getItem('vendor_auth_redirect');
    if (vendorRedirect) {
      sessionStorage.removeItem('vendor_auth_redirect');
      navigate(vendorRedirect, { replace: true });
      return;
    }

    if (window.location.pathname !== '/') return;
    const targetRoute = getTargetRouteForRole(user.role);
    navigate(targetRoute, { replace: true });
  }, [navigate, user]);

  if (!user) {
    return (
      <PageLoader>
        <AuthLandingPage onLogin={login} />
      </PageLoader>
    );
  }

  return <FullPageSpinner message="Redirecting to dashboard..." />;
};
